import React from 'react'
import { useInternationalization } from '../../features/i18n'
import { useSystem } from '../../features/system/hook'
import { RequiredLabel } from '../form'
import { FormDashboardLabel as Label } from './label'
import { SelectCheckbox } from './select-checkbox'

const OrganizationTypeSelect = ({
  defaultValues,
  updateForm = () => {},
  label,
  placeholder = "Choose"
}) => {
  const { translate } = useInternationalization()
  const finalLabel = label ? label : <Label>{translate('ORGANIZATION', 'type')} <RequiredLabel /></Label>
  const { organizationTypeOptions } = useSystem()
  return (
    <React.Fragment>
      {finalLabel}
      <SelectCheckbox
        className="text-sm"
        placeholder={placeholder}
        value={defaultValues}
        options={organizationTypeOptions}
        allowSelectAll={true}
        allOption={{label: 'Select All', value: 'all'}}
        onChange={(value) => {
          updateForm({
            target: {
              name: 'organizationType',
              value,
            }
          })
        }}
      />
    </React.Fragment>
  )
}

export { OrganizationTypeSelect }
